module.exports = __webpack_public_path__ + "static/media/post.a350de1f.svg";